// TODO: organize

export default {
  // MISC
  countries: "/admin/api/v1/request-countries-list/",
  envVars: "/admin/api/v1/env-vars/",
  publicEnvVars: "/admin/api/v1/env-vars-public/",
  studySearch: "/core/api/v1/global-study-search",
  globalSearch: "/core/api/v1/global-search/",
  globalSponsorFilter: "/auth/api/v1/global-sponsor-filter/",
  globalFilter: "/auth/api/v1/global-filter/",
  notifications: "/core/api/v1/user/notifications/",

  // auth
  login: "/auth/api/v1/login/",
  logout: "/auth/api/v1/logout/",
  resetLoginPassword: "/auth/api/v1/users/password-reset/confirm/",

  // account settings
  subscriptionManager: "/admin/api/v1/subscription-manager/",

  // ACTIVITIES (project types)
  activities: "/activity/api/v1/activities/",
  // activities - admin
  activityTypes: "/admin/api/v1/project-types/",
  activityTypesList: "/admin/api/v1/project-types-list/",
  activityCategories: "/admin/api/v1/project-categories-list/",
  // activities - reports
  manageActivities: "/reports/api/v1/activity/",

  // REQUESTS (data sharing)
  requests: "/datasharing/api/v1/requests/",
  requestList: "/datasharing/api/v1/request-list/",
  requestsGrid: "/datasharing/api/v1/requests-grid/",
  requestSource: "/datasharing/api/v1/request-source-list/",
  // requests - admin
  requestTypesList: "/admin/api/v1/request-types-list/",
  requestTypes: "/admin/api/v1/request-types/",
  requestFields: "/admin/api/v1/request-custom-fields/",
  requestSecondaryIdTypes: "/admin/api/v1/request-secondary-id-types/",
  requestCategories: "/admin/api/v1/request-categories/",
  requestRoles: "/admin/api/v1/request-roles-list/",
  // requests - auth
  favoriteRequests: "/auth/api/v1/favorite-requests/",
  // requests - reports
  requestReport: "/reports/api/v1/request/",

  // action items
  actionItems: "/actionitems/api/v1/items/",

  // admin
  allLockableFields: "/admin/api/v1/all-lockable-fields/",
  cancelProtocolUpload: "/authoring/api/v1/tasks/prs-protocol-cancel-upload",
  cancelSitesUpload: "/sites/api/v1/tasks/prs-sites-cancel-upload/",
  assessmentSubTypes: "/admin/api/v1/assessment-subtypes/",
  assessmentTypes: "/admin/api/v1/assessment-types/",
  checklistTemplates: "/admin/api/v1/checklist-templates/",
  collaboratorTypes: "/admin/api/v1/collaborator-types/",
  commentTypes: "/admin/api/v1/comment-types/",
  conditions: "/admin/api/v1/conditions/",
  dataChangeApprovalForm: "/admin/api/v1/pm-study-flagging-config/",
  defaultAuthoringForm: "/admin/api/v1/default-authoring-form/",
  documentTypes: "/admin/api/v1/document-types/",
  globalSiteSettings: "/admin/api/v1/global-site-settings/",
  lockedFields: "/admin/api/v1/locked-fields/",
  protocolMaintenanceSettings: "/admin/api/v1/protocol-maintenance-settings/",
  prsUsers: "/admin/api/v1/prs-users/",
  pollTask: "/admin/api/v1/tasks/",
  sponsors: "/admin/api/v1/sponsors/",
  submissionReasons: "/admin/api/v1/submission-reasons/",
  reportConfigsList: "/admin/api/v1/report-configs-list/",
  reportConfigs: "/admin/api/v1/report-configs/",
  tags: "/core/api/v1/tags/",

  /** Admin.Configuration */

  // authoring
  authoring: "/authoring/api/v1/studies/",
  prsProtocolDownload: "/authoring/api/v1/tasks/prs-protocol-download",
  prsProtocolSiteUpload: "/authoring/api/v1/tasks/prs-protocol-sites-upload",

  // ETL
  aeImport: "/etl/api/v1/ae-manual-import/",
  sitesImportInfo: "/etl/api/v1/sites-etl-latest-import-info/",

  // core - studies
  studies: "/core/api/v1/studies/",
  studiesGrid: "/core/api/v1/studies-grid/",
  studiesList: "/core/api/v1/studies-list/",

  // Documents (files)
  documentsGrid: "/documents/api/v1/documents-grid/",
  documents: "/documents/api/v1/documents/",
  extraDocumentFields: "/admin/api/v1/docs-json-schema/",
  reviewerDocuments: "/documents/api/v1/reviewer-documents/",
  globalDocsSearch: "/documents/api/v1/global-doc-search",
  allDocumentsInSystem: "/documents/api/v1/all-docs/",

  // grids
  gridPresetsAdmin: "/admin/api/v1/grid-presets/",
  gridPresets: "/reports/api/v1/presets/grid/",
  gridFilters: "/reports/api/v1/presets/filter/",

  // site management
  siteManagementDetails: "/sites/api/v1/studies/",
  prsSitesUpload: "/sites/api/v1/tasks/prs-sites-upload/",

  // my prime
  myPrimeUser: "/reports/api/v1/dashboard/my-prime-grid-user/",
  // myPrimeUserDetail: '/reports/api/v1/dashboard/my-prime-grid-user/',
  myPrimeClient: "/admin/api/v1/my-prime-grid-client/",
  calcMetrics: "/reports/api/v1/dashboard/calc-metrics",

  // Metrics
  activityDashboard: "/reports/api/v1/metrics/activity/",
  detailedActivityDashboard: "/reports/api/v1/metrics/detailed-activity/",
  assessmentDashboard: "/reports/api/v1/metrics/assessment/",
  detailedAssessmentDashboard: "/reports/api/v1/metrics/detailed-assessment/",

  // metrics reports
  manageActionItems: "/reports/api/v1/action-items/",

  // reports
  reports: "/reports/api/v1/all-reports/",
  reportRegen: "/reports/api/v1/handle-reports/",
  dataChangeReport: "/reports/api/v1/data-change/",
  newStudyReport: "/reports/api/v1/new-study/",
  exportReport: "/reports/api/v1/export-report/",

  // all-maintenance "report"
  allMaintenanceReport: "/reports/api/v1/all-maintenance/",

  // submissions
  submissionsUpload: "/authoring/api/v1/tasks/prs-submission-upload",

  // User
  userInfo: "/auth/api/v1/user-info/",
  users: "/auth/api/v1/users/",
  usersGrid: "/auth/api/v1/users-grid/",
  resetPassword: "/auth/api/v1/users/change-pwd",
  forgotPassword: "/auth/api/v1/users/password-reset/",
  pwdExpiryDeadline: "/auth/api/v1/users/pwd-expiry-deadline",

  // Dropdown
  usersList: "/auth/api/v1/users-list/",
  userPermissions: "/admin/api/v1/user-permissions/",
  userSettings: "/auth/api/v1/user-settings/",
  favoriteStudies: "/auth/api/v1/favorites/",

  // user roles
  roles: "/admin/api/v1/roles-list/",

  // upload history
  uploadHistory: "/authoring/api/v1/prs-submission-history/",

  // workflows
  workflow: "/workflow/api/v1/workflows/",

  // misc. lists for dropdowns
  allowedClients: "/admin/api/v1/allowed-clients-list/",
  emailTemplates: "/admin/api/v1/email-template-list/",
  registries: "/admin/api/v1/registries-list/",
  regions: "/admin/api/v1/regions-list/",
  viewTypes: "/admin/api/v1/view-types-list/",
  programName: "/core/api/v1/program-name-list/",
  therapeuticArea: "/core/api/v1/therapeutic-area-list/",
  programId: "/core/api/v1/program-id-list/",
  filterSet: "/admin/api/v1/filter-set/",
  metricConfigs: "/admin/api/v1/metric-configs-list/",
  //auditlogs
  searchAuditLogs: "/admin/api/v1/search-audit-log/",
  compareAuditLogs: "/admin/api/v1/compare-audit-log/",
  getAuditLogData: "/admin/api/v1/fetch-audit-log/",
}
